import React, { Component, PropTypes } from 'react'

import { detectAndShowErrors, filterObject, normaliseMap, yesNoOptions } from './utils'

import Header from './header'
import Progress from '../containers/progress'

import {
    formHandler,
    TextInput,
    RadioInput,
    Button,
    Label,
    MultipleCheckbox,
    Select,
} from './ui'

function sendPatchRequest(field) {
    this.props.updateValueAndSendPatchRequest({
        [field]: this.props.data[field],
    })
}

class Experience extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        actions: PropTypes.shape({
            loadExperience: PropTypes.func.isRequired,
            patchExperience: PropTypes.func.isRequired,
            submitExperience: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        crew: PropTypes.shape({
            industry_type: PropTypes.array,
            language: PropTypes.array,
        }).isRequired,
        crew_actions: PropTypes.shape({
            loadIndustryTypes: PropTypes.func.isRequired,
            loadLanguages: PropTypes.func.isRequired,
        }).isRequired,
        location: PropTypes.object,
        location_actions: PropTypes.object,
        personal: PropTypes.shape({
            experience: PropTypes.object,
            experience_errors: PropTypes.object,
            resume: PropTypes.object,
            resume_upload_progress: PropTypes.object,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: props.personal.experience,
        }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this.props.personal.experience) {
            this.props.actions.loadExperience(this.props.account.user.crew.uuid)
        }
        if (! this.props.crew.industry_type) {
            this.props.crew_actions.loadIndustryTypes()
        }
        if (! this.props.crew.language) {
            this.props.crew_actions.loadLanguages()
        }
    }

    componentWillReceiveProps(nextProps) {
        // Update the state data when we receive new personal data props
        if (nextProps.personal && ! (
            this.props.personal &&
            nextProps.personal.experience === this.props.personal.experience
        )) {
            this.setState({
                data: nextProps.personal.experience,
            })
        }

        detectAndShowErrors(this.props, nextProps, 'personal.experience_errors')
    }

    submitExperience = () => {
        this.props.actions.submitExperience(
            this.state.data,
            this.props.account.user.crew.uuid,
            this.props.account.user.crew,
        )
    }

    updateValueAndSendPatchRequest = (data) => {
        this.updateValue(data)
        this.sendPatchRequest(data)
    }

    sendPatchRequest = (data) => {
        // if an array of fields was passed in, use that to just get data from the state
        if (Array.isArray(data)) {
            data = filterObject(this.state.data, data)
        }

        this.props.actions.patchExperience(data, this.props.account.user.crew.uuid)
    }

    render() {
        const options = {
            industryTypeOptions: normaliseMap(this.props.crew.industry_type),
            languageOptions: normaliseMap(this.props.crew.language),
        }

        const errors = this.props.personal.experience_errors

        let non_field_errors = null

        if (errors.non_field_errors) {
            non_field_errors = (
                <div className="content__inner">
                    <div className="alert alert--error">
                        { errors.non_field_errors.map((error, index) => (
                            <span key={ index }>{ error }<br /></span>
                        )) }
                    </div>
                </div>
            )
        }

        return (
            <div>
                <Header title="Experience" />

                <div className="content">
                    <Progress stage="experience" />

                    { non_field_errors }

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Work Portfolio
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <PortfolioForm
                                    data={ this.state.data }
                                    errors={ errors }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Industry Experience
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <IndustryForm
                                    data={ this.state.data }
                                    errors={ errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Languages Spoken
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <LanguageForm
                                    data={ this.state.data }
                                    errors={ errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Resume (CV)
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <ResumeForm
                                    actions={ this.props.actions }
                                    crewUUID={ this.props.account.user.crew.uuid }
                                    data={ this.state.data }
                                    errors={ errors }
                                    options={ options }
                                    progress={ this.props.personal.resume_upload_progress }
                                    resume={ this.props.personal.resume }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    References
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <ReferencesForm
                                    data={ this.state.data }
                                    errors={ errors }
                                    location={ this.props.location }
                                    location_actions={ this.props.location_actions }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Full Time Placement
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <PlacementForm
                                    data={ this.state.data }
                                    errors={ errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="submit-row">
                    <Button
                        buttonOnly
                        loading={ this.props.appState.loading || ! this.props.personal.experience }
                        onClick={ this.submitExperience }
                        status="primary"
                    >
                        Save
                    </Button>
                </div>
            </div>
        )
    }
}

class PortfolioForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object,
        updateValue: PropTypes.func.isRequired,
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        let work_portfolio_error = null

        if (errors.work_portfolio) {
            work_portfolio_error = (
                <div className="alert alert--error">
                    { errors.work_portfolio.map((error, index) => (
                        <span key={ index }>{ error }<br /></span>
                    )) }
                </div>
            )
        }

        return (
            <div className="form">
                { work_portfolio_error }

                <p className="text-strong">
                    PLEASE ENTER ALL WEB ADDRESSES WITHOUT “HTTP://” AND “WWW” - CORRECT INPUT
                    EXAMPLE: VIMEO.COM
                </p>

                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <Label inline>Personal Website</Label>
                    </div>
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.website_url }
                            handleBlur={ sendPatchRequest.bind(this, 'website_url') }
                            name="website_url"
                            type="text"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.website_url }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <Label inline>Direct link to reel</Label>
                    </div>
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.demo_reel_url }
                            handleBlur={ sendPatchRequest.bind(this, 'demo_reel_url') }
                            name="demo_reel_url"
                            type="text"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.demo_reel_url }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <Label inline>Vimeo / YouTube Profile</Label>
                    </div>
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.video_url }
                            handleBlur={ sendPatchRequest.bind(this, 'video_url') }
                            name="video_url"
                            type="text"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.video_url }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <Label inline>IMDB Profile</Label>
                    </div>
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.imdb_url }
                            handleBlur={ sendPatchRequest.bind(this, 'imdb_url') }
                            name="imdb_url"
                            type="text"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.imdb_url }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <Label inline>Additional Personal / Portfolio</Label>
                    </div>
                    <div className="grid__span-8">
                        <TextInput
                            error={ errors.additional_urls }
                            handleBlur={ sendPatchRequest.bind(this, 'additional_urls') }
                            name="additional_urls"
                            subHelp="Flickr, Blogs, Portoflios, Etc (Optional but strongly recommended)"
                            type="text"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.additional_urls }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

class IndustryForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object,
        options: PropTypes.shape({
            industryTypeOptions: PropTypes.array.isRequired,
        }).isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    _industryTypeOptionsLeft() {
        const options = this.props.options.industryTypeOptions
        const total = options.length
        const firstHalf = Math.ceil(total / 2)

        return options.slice(0, firstHalf)
    }

    _industryTypeOptionsRight() {
        const options = this.props.options.industryTypeOptions
        const total = options.length
        const secondHalf = Math.ceil(total / 2)

        return options.slice(secondHalf, total)
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-6">
                        <MultipleCheckbox
                            error={ errors.industry }
                            name="industry"
                            options={ this._industryTypeOptionsLeft() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.industry }
                        />
                    </div>
                    <div className="grid__span-6">
                        <MultipleCheckbox
                            error={ errors.industry }
                            name="industry"
                            options={ this._industryTypeOptionsRight() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.industry }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

class LanguageForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object,
        options: PropTypes.shape({
            languageOptions: PropTypes.array.isRequired,
        }).isRequired,
        updateValue: PropTypes.func.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    _languageOptionsLeft() {
        const options = this.props.options.languageOptions
        const total = options.length
        const firstHalf = Math.ceil(total / 2)

        return options.slice(0, firstHalf)
    }

    _languageOptionsRight() {
        const options = this.props.options.languageOptions
        const total = options.length
        const secondHalf = Math.floor(total / 2)

        return options.slice(secondHalf, total)
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-6">
                        <MultipleCheckbox
                            error={ errors.languages }
                            name="languages"
                            options={ this._languageOptionsLeft() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.languages }
                        />
                    </div>
                    <div className="grid__span-6">
                        <MultipleCheckbox
                            error={ errors.languages }
                            name="languages"
                            options={ this._languageOptionsRight() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.languages }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-6">
                        <TextInput
                            error={ errors.other_languages }
                            handleBlur={ sendPatchRequest.bind(this, 'other_languages') }
                            label="Other languages"
                            name="other_languages"
                            type="text"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.other_languages }
                        />
                    </div>
                </div>
            </div>
        )
    }

}

class ResumeForm extends Component {
    static propTypes = {
        actions: PropTypes.shape({
            uploadResume: PropTypes.func.isRequired,
            uploadResumeError: PropTypes.func.isRequired,
        }).isRequired,
        crewUUID: PropTypes.string.isRequired,
        data: PropTypes.object,
        errors: PropTypes.object,
        progress: PropTypes.number,
        resume: PropTypes.shape({
            resume: PropTypes.string,
        }),
    }

    _onFileChange = (e) => {
        if (e.target.files.length) {
            const FIVE_MEBIBYTES = 5242880
            const file = e.target.files[0]

            if (file.size > FIVE_MEBIBYTES) {
                this.props.actions.uploadResumeError({ resume: [ 'The file size must be less than 5MB' ] })
            } else {
                this.props.actions.uploadResume(e.target.files[0], this.props.crewUUID)
            }
        }
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        let field_errors = null

        if (errors.resume) {
            field_errors = errors.resume.map(
                (error, index) => <span key={ index }>{ error }<br /></span>
            )

            field_errors = (
                <div className="alert alert--error">
                    { field_errors }
                </div>
            )
        }

        let resume = null

        if (this.props.resume && this.props.resume.resume) {
            const resumeURL = this.props.resume.resume

            resume = (
                <a
                    className="btn btn--primary"
                    href={ `${ resumeURL }` }
                    target="_blank"
                >
                    Download resume
                </a>
            )
        }

        let progress = null

        // eslint-disable-next-line no-magic-numbers
        if (this.props.progress && this.props.progress < 100) {
            const style = {
                width: `${ this.props.progress }%`,
            }

            progress = (
                <div className="progress-bar">
                    <div className="progress-bar__meter" style={ style } />
                </div>
            )
        } else {
            progress = <input accept="application/pdf,image/png" onChange={ this._onFileChange } type="file" />
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-12">
                        { field_errors }
                        { resume }
                        <p>Please upload a resume (CV) in PDF format. The file size must not exceed 5MB.</p>
                        { progress }
                    </div>
                </div>
            </div>
        )
    }
}

class ReferencesForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object,
        location: PropTypes.shape({
            countries: PropTypes.array,
        }).isRequired,
        location_actions: PropTypes.shape({
            loadCountries: PropTypes.func.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: props.data || {},
        }

        this.defaultReferenceData = {
            name: null,
            phone_dial_code: null,
            email: null,
            phone: null,
            company: null,
        }

        // Bind handler functions
        this.handleAddInnerForm = formHandler.handleAddInnerForm.bind(this)
        this.handleChangeInnerForm = formHandler.handleChangeInnerForm.bind(this)
        this.handleDeleteInnerForm = formHandler.handleDeleteInnerForm.bind(this)
    }

    componentWillMount() {
        if (! this.props.location.countries) {
            this.props.location_actions.loadCountries()
        }
    }

    componentWillReceiveProps(nextProps) {
        // If we receive references from the props data, update the state.
        if (nextProps.data && ! (
            this.props.data &&
            nextProps.data === this.props.data
        )) {
            this.setState({
                data: nextProps.data,
            })
        }
    }

    _countryDialCodeOptions() {
        if (! this.props.location.countries) {
            return []
        }

        return this.props.location.countries.map((item) => {
            let label = item.label

            if (item.dial_code) {
                label += ` (${ item.dial_code })`
            }

            return {
                value: item.value,
                label,
            }
        })
    }

    _handleAddReference = () => {
        // Create a new reference data object by cloning the default values
        const newReferenceData = { ...this.defaultReferenceData }

        // Populate the new form data to the state
        this.handleAddInnerForm('references', newReferenceData)
    }

    _handleChangeReference = (index, data) => {
        // Push the updated data to the state data
        this.handleChangeInnerForm('references', index, data, 'updateValue')
    }

    _handleCommitReference = (index, data) => {
        // Push the updated data to the state data
        this.handleChangeInnerForm('references', index, data, 'updateValueAndSendPatchRequest')
    }

    _handleDeleteReference = (index) => {
        // eslint-disable-next-line no-alert
        if (confirm('Are you sure you wish to delete this reference?') === true) {
            // Remove the reference from the state data
            this.handleDeleteInnerForm('references', index, 'updateValueAndSendPatchRequest')
        }
    }

    render() {
        if (! this.props.data) {
            return null
        }

        const errors = this.props.errors

        let referenceForms = null

        if (this.props.data.references) {
            referenceForms = this.props.data.references.map((item, index) => {
                // Assign the index to the item for use in the handle change
                item.index = index

                // Add error if we have any
                let formErrors = {}

                if (errors.references && errors.references[index]) {
                    formErrors = errors.references[index]
                }

                return (
                    <ReferenceForm
                        countryDialCodeOptions={ this._countryDialCodeOptions() }
                        data={ item }
                        errors={ formErrors }
                        handleChangeField={ this._handleChangeReference }
                        handleCommitField={ this._handleCommitReference }
                        handleDeleteItem={ this._handleDeleteReference }
                        key={ index }
                    />
                )
            })
        }

        let referenceErrors = null

        if (errors.references) {
            // If the first key is not a list, then the error is for the nested form
            if (typeof errors.references[0] === 'string') {
                referenceErrors = errors.references.map(
                    (error, index) => <span key={ index }>{ error }<br /></span>
                )

                referenceErrors = (
                    <div className="alert alert--error">
                        { referenceErrors }
                    </div>
                )
            }
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-12">
                        <p>You must enter at least two references.</p>

                        { referenceErrors }
                        { referenceForms }

                        <button
                            className="btn btn--create"
                            onClick={ this._handleAddReference }
                            type="button"
                        >
                            Add reference
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

class ReferenceForm extends Component {
    static propTypes = {
        countryDialCodeOptions: PropTypes.array,
        data: PropTypes.object,
        errors: PropTypes.object,
        handleChangeField: PropTypes.func.isRequired,
        handleCommitField: PropTypes.func.isRequired,
        handleDeleteItem: PropTypes.func.isRequired,
    }

    updateValue = (data) => {
        const newData = {
            ...this.props.data,
            ...data,
        }

        this.props.handleChangeField(this.props.data.index, newData)

        return newData
    }

    commitData = (data = this.props.data) => {
        this.props.handleCommitField(this.props.data.index, data)
    }

    updateValueAndCommitData = (data) => {
        this.commitData(this.updateValue(data))
    }

    deleteItem = () => {
        this.props.handleDeleteItem(this.props.data.index)
    }

    render() {
        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-2">
                        <TextInput
                            error={ this.props.errors.name }
                            handleBlur={ this.commitData }
                            name="name"
                            placeholder="Name"
                            type="text"
                            updateValue={ this.updateValue }
                            value={ this.props.data.name }
                        />
                    </div>
                    <div className="grid__span-2">
                        <Select
                            error={ this.props.errors.phone_dial_code }
                            name="phone_dial_code"
                            options={ this.props.countryDialCodeOptions }
                            placeholder="Country code"
                            updateValue={ this.updateValueAndCommitData }
                            value={ this.props.data.phone_dial_code }
                        />
                    </div>
                    <div className="grid__span-2">
                        <TextInput
                            error={ this.props.errors.phone }
                            handleBlur={ this.commitData }
                            name="phone"
                            placeholder="Phone"
                            type="text"
                            updateValue={ this.updateValue }
                            value={ this.props.data.phone }
                        />
                    </div>
                    <div className="grid__span-3">
                        <TextInput
                            error={ this.props.errors.email }
                            handleBlur={ this.commitData }
                            name="email"
                            placeholder="Email"
                            type="text"
                            updateValue={ this.updateValue }
                            value={ this.props.data.email }
                        />
                    </div>
                    <div className="grid__span-2">
                        <TextInput
                            error={ this.props.errors.company }
                            handleBlur={ this.commitData }
                            name="company"
                            placeholder="Company"
                            type="text"
                            updateValue={ this.updateValue }
                            value={ this.props.data.company }
                        />
                    </div>
                    <div className="grid__span-1">
                        <Button onClick={ this.deleteItem } status="delete">&times;</Button>
                    </div>
                </div>
            </div>
        )
    }
}

class PlacementForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-12">
                        <RadioInput
                            error={ errors.job_placement }
                            label={
                                'We recruit for full time positions for our clients. Are you ' +
                                'interested in being considered for full time job placements?'
                            }
                            name="job_placement"
                            options={ yesNoOptions() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.job_placement }
                        />
                    </div>
                </div>
            </div>
        )
    }

}

export default Experience



// WEBPACK FOOTER //
// ./app/components/experience.js